module.exports = __webpack_public_path__ + "static/media/article-slider.d6d3a879.png";